import React from 'react';
import {CustomersUIProvider} from '../components/CustomersUIContext';
import {CustomersLoadingDialog} from '../components/customers-loading-dialog/CustomersLoadingDialog';
import {CustomersCard} from './CustomersCard';

export function CustomersPage() {
  return (
    <CustomersUIProvider>
      <CustomersLoadingDialog />
      <CustomersCard/>
    </CustomersUIProvider>
  );
}
